"use client"
import { Country } from "@/actions/selection/get-all-countries-and-paths"
import CountryPickerSelectionItems from "@/app/(site)/_components/Organisms/Header/CountryPickerSelection/CountryPickerSelectionItems"
import { ShippingCountryCode } from "@/data/shipping-country-code"
import { LanguageOption } from "@/data/supported-languages"

export default function SiteSelectorLink({
    theme,
    getCountries,
    getAndTransformCountriesWithLanguages
}: {
    theme?: "light" | "dark"
    getCountries: Country[]
    getAndTransformCountriesWithLanguages: Record<ShippingCountryCode, LanguageOption[]>
}) {
    return (
        <div className="align-center flex h-full w-[100%] max-w-4xl flex-col justify-center p-24 sm:w-[60%] md:w-[40%]">
            <h1 className="mb-32 text-left text-white font_tradeGothicLTPro_Light_32_120">
                Select your desired shipping destination and language below:
            </h1>
            <ul className="flex h-[80svw] flex-col justify-between overflow-y-auto rounded-md bg-black bg-opacity-80 pb-24 pr-16 text-white custom-scrollbar md:h-[60vh] md:pt-30">
                <CountryPickerSelectionItems
                    countries={getCountries}
                    countriesWithLanguages={getAndTransformCountriesWithLanguages}
                    theme={theme}
                />
            </ul>
        </div>
    )
}
